/* eslint-disable default-param-last */
/* eslint-disable no-use-before-define */
/* eslint-disable no-useless-return */
import * as Sentry from '@sentry/react';
import { actionType as act } from 'Config/actionTypes';
import axios from 'axios';
import { getTokenJWT, GetToken, DecodeCurrentUser } from 'Helpers';

const ENV = process.env.REACT_APP_BUILDTIME_ENV;

// interceptors
axios.interceptors.request.use((req) => {
  req.meta = req.meta || {};
  req.meta.requestStartedAt = new Date().getTime();
  return req;
});

axios.interceptors.response.use((x) => {
  x.responseTime = new Date().getTime() - x.config.meta.requestStartedAt;
  return x;
});

const sentryEventError = (error) => {
  const {
    response: {
      config: { baseURL, url },
      data,
      // headers, --> TODO
      status,
    },
  } = error;

  // get error message
  const errMessage = typeof (data) === 'string' ? data : data?.error;

  // get severity status
  let severity = '';
  if (status === 401) {
    severity = 'info';
  }
  if (status === 408) {
    severity = 'warning';
  }
  if (status >= 500) {
    severity = 'error';
  }

  const currentCompanyId = JSON.parse(DecodeCurrentUser())?.current_company?.company?.id;
  const currentUserId = JSON.parse(DecodeCurrentUser())?.current_user?.id;
  // TODO: Will remove / add request-id if found solution in staging issue
  // `request-id: ${headers['x-request-id']},  

  if (ENV !== 'development') {
    Sentry.captureMessage(
      `[${ENV}][cid: ${currentCompanyId}][uid: ${currentUserId}][endpoint: ${baseURL}${url}] ${errMessage}`,
      severity
    );
  }

  return false;
};

// ApiCall
export default function ApiCall(
  dispatch,
  actionType,
  method,
  baseURL,
  url,
  body,
  token = '',
  params,
  headers = null,
  responseType = 'json'
) {
  dispatch({ type: `${actionType}_LOADING` });
  try {
    return api(method, baseURL, url, body, token, params, headers, responseType)
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: `${actionType}_RESULT`, result: res, status: res.status });

          if (responseType === 'csv') {
            const fileName = actionType.toLowerCase().split('_');
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            fileName.pop();
            link.href = url;
            link.setAttribute('download', `${fileName.join('-')}.csv`);
            document.body.appendChild(link);
            link.click();
          }
        } else {
          // @ts-ignore
          dispatch({ type: `${actionType}_FAILED`, err: res.message, status: res.status });
        }
      })
      .catch((error) => {
        dispatch({
          type: `${actionType}_ERROR`,
          err: error?.response?.data,
          status: error?.response?.status,
        });
        dispatch({
          type: act.ERROR_STATUS,
          err: error?.response?.data,
          status: error?.response?.status,
        });
        sentryEventError(error);
      });
  } catch (error) {
    dispatch({ type: `${actionType}_FAILED`, err: error });
    sentryEventError(error);
  }
}

export function ApiCallInfiniteScroll(
  dispatch,
  actionType,
  method,
  baseURL,
  url,
  body,
  token = '',
  params,
  isReset = false
) {
  dispatch({ type: `${actionType}_LOADING` });
  try {
    return api(method, baseURL, url, body, token, params)
      .then((res) => {
        if (res.status === 200) {
          if (isReset) {
            dispatch({ type: `${actionType}_RESET`, result: res });
          } else {
            dispatch({ type: `${actionType}_RESULT`, result: res });
          }
        } else {
          // @ts-ignore
          dispatch({ type: `${actionType}_FAILED`, err: res.message });
        }
      })
      .catch((error) => {
        dispatch({ type: `${actionType}_FAILED`, err: error });
        sentryEventError(error);
      });
  } catch (error) {
    dispatch({ type: `${actionType}_FAILED`, err: error });
    sentryEventError(error);
  }
}

// api
export function api(
  method,
  baseURL,
  url,
  body,
  token = '',
  params,
  headers = null,
  responseType = 'json'
) {
  return axios({
    method,
    baseURL,
    url: url + (['csv', 'pdf'].indexOf(responseType) !== -1 ? `.${responseType}` : ''),
    headers: {
      'Content-Type': '*/*',
      Accept: 'application/json',
      Authorization: token ? GetToken(token) : getTokenJWT(),
      ...headers,
    },
    data: body,
    params,
    responseType: responseType !== 'json' ? 'blob' : '',
  });
}
